export const formatDefinition = (definition: string, languageLabel?: string) => {
  const match = definition.match(/\[(.*?)\]/);
  const category = match ? match[1] : '';
  const definitionLabel = match ? definition.replace(match[0], '').trim() : definition;

  let label = definitionLabel;
  if (languageLabel) {
    label = languageLabel.replace(/\s*\[.*?\]\s*/g, '').trim() || definitionLabel;
  }
  return { category, label };
};
